<template lang="pug">
  transition(name='fade')
    div(class="c-modal", @click.self="$emit('hide')")
      div(class="c-modal__content u-bg-black"  style='width: 900px')
        div(class='c-video')
          iframe(slot='content' width="100%", height="200", :src="currentVideoUrl", frameborder="0" allowfullscreen)
</template>

<script>
  export default {
    props: {
      url: {
        required: true
      }
    },

    computed: {
      currentVideoUrl () {
        return `https://www.youtube.com/embed/${this.url}?rel=0&amp;showinfo=0;autoplay=1`
      }
    },

    beforeCreate () {
      window.$('body').css('overflow-y', 'hidden')
    },

    beforeDestroy () {
      window.$('body').css('overflow-y', '')
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/ModalVideo.vue